// Block iconography: the one visual vocabulary for workflow steps.
//
// The canvas (WorkflowBuilder) and the copilot's plan preview must render the
// same block as the same icon and colour, or the plan an owner approves in chat
// stops looking like the workflow they land on. Shared here so there is one map,
// not two that drift.

import { Brain, Clock, GitBranch, Repeat, Send, Zap, type LucideIcon } from "lucide-react";

export interface BlockStyle {
  icon: LucideIcon;
  /** Border + background + text classes for the block's chip. */
  chip: string;
  label: string;
  blurb: string;
}

export const BLOCK_STYLES: Record<string, BlockStyle> = {
  trigger: { icon: Zap, chip: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "Trigger", blurb: "The event that starts the workflow." },
  condition: { icon: GitBranch, chip: "bg-blue-50 text-blue-700 border-blue-200", label: "Control", blurb: "Guide the workflow with conditions and loops — choose a path or repeat steps until a condition is met." },
  decision: { icon: Brain, chip: "bg-violet-50 text-violet-700 border-violet-200", label: "Decision", blurb: "The AI writes personalised content for a later step." },
  execution: { icon: Send, chip: "bg-primary/10 text-primary border-primary/20", label: "Execution", blurb: "The action the workflow carries out." },
  delay: { icon: Clock, chip: "bg-muted text-muted-foreground border-border", label: "Wait", blurb: "A time gap before the next step." },
  // The second Control block, so it shares the Control colour.
  loop: { icon: Repeat, chip: "bg-blue-50 text-blue-700 border-blue-200", label: "Repeat until", blurb: "Repeat the blocks inside it until a stop rule matches, e.g. nudge every 2 days until they reply." },
};
